import axios from 'axios';
import getPromotionsApiRoot from './getPromotionsApiRoot';

export default function putReminder(id: string): Promise<void> {
  return axios.put(
    `${getPromotionsApiRoot()}/reminder/${encodeURIComponent(id)}`,
  );
}
